import { Component, OnInit, Input } from '@angular/core';
import { Globals } from '../../_globals';
import { ActivatedRoute } from '@angular/router';

declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  children: any;
}

export const SUPERROUTES: RouteInfo[] = [
  {
    path: '/super/dashboard',
    title: 'Dashboard',
    icon: 'now-ui-icons business_chart-bar-32',
    class: '',
    children: [],
  },
  {
    path: '/super/group-users',
    title: 'Management Groups',
    icon: 'now-ui-icons business_briefcase-24',
    class: '',
    children: [],
  },
  {
    path: '/super/owner-users',
    title: 'Store Owners',
    icon: 'now-ui-icons users_circle-08',
    class: '',
    children: [],
  },
  {
    path: '/super/stores',
    title: 'Stores',
    icon: 'now-ui-icons shopping_shop',
    class: '',
    children: [],
  },
  { path: '/super/apps', title: 'Apps', icon: 'now-ui-icons tech_mobile', class: '', children: [] },
];

export const GROUPROUTES: RouteInfo[] = [
  {
    path: '/group/dashboard',
    title: 'Dashboard',
    icon: 'now-ui-icons business_chart-bar-32',
    class: '',
    children: [],
  },
  {
    path: '/group/stores',
    title: 'Stores',
    icon: 'now-ui-icons shopping_shop',
    class: '',
    children: [],
  },
  {
    path: '/group/owner-users',
    title: 'Store Owners',
    icon: 'now-ui-icons users_circle-08',
    class: '',
    children: [],
  },
];

export const OWNERROUTES: RouteInfo[] = [
  {
    path: '/owner/dashboard',
    title: 'Dashboard',
    icon: 'now-ui-icons business_chart-bar-32',
    class: '',
    children: [],
  },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
  roleMenuItems: any[];
  storeMenuItems: any[];

  role: any;
  routeRole: any;
  resolverData: any;
  storeId: any;

  constructor(public globals: Globals, private route: ActivatedRoute) {
    this.role = globals.user.role;
    this.routeRole = globals.user.routeRole;
    this.storeId = globals.store.id;
  }

  ngOnInit() {
    const STOREROUTES: RouteInfo[] = [
      {
        path: '/' + this.routeRole + '/store',
        title: 'Store Setup',
        icon: 'now-ui-icons ui-2_settings-90',
        class: '',
        children: [],
      },
      {
        path: '/' + this.routeRole + '/categories',
        title: 'Grocery Categories',
        icon: 'now-ui-icons design_bullet-list-67',
        class: '',
        children: [],
      },
      {
        path: '/' + this.routeRole + '/food-to-go-categories',
        title: 'Food To Go Categories',
        icon: 'now-ui-icons shopping_delivery-fast',
        class: '',
        children: [],
      },
      // {
      //     path: '/' + this.routeRole + '/kiosk-categories',
      //     title: 'Kiosk Categories',
      //     icon: 'now-ui-icons files_single-copy-04',
      //     class: '',
      //     children: [],
      // },
      {
        path: '/' + this.routeRole + '/products-v2/',
        title: 'Products',
        icon: 'now-ui-icons shopping_bag-16',
        class: '',
        children: [],
      },
      // {
      //     path: '/' + this.routeRole + '/products',
      //     title: 'Products Old',
      //     icon: 'now-ui-icons shopping_bag-16',
      //     class: '',
      //     children: [],
      // },
      {
        path: '/' + this.routeRole + '/orders',
        title: 'Orders',
        icon: 'now-ui-icons business_money-coins',
        class: '',
        children: [],
      },
      {
        path: '/' + this.routeRole + '/custom-builders',
        title: 'Custom Builders',
        icon: 'now-ui-icons objects_spaceship',
        class: '',
        children: [],
      },
      {
        path: '/' + this.routeRole + '/image-bank',
        title: 'Image Bank',
        icon: 'now-ui-icons media-1_album',
        class: '',
        children: [],
      },
      {
        path: '/' + this.routeRole + '/order-groups',
        title: 'Workplace Groups',
        icon: 'now-ui-icons business_badge',
        class: '',
        children: [],
      },
      {
        path: '/' + this.routeRole + '/customers',
        title: 'Customers',
        icon: 'now-ui-icons users_single-02',
        class: '',
        children: [],
      },
      {
        path: '/' + this.routeRole + '/console-users',
        title: 'Console Users',
        icon: 'now-ui-icons tech_tablet',
        class: '',
        children: [],
      },
      // { path: '/' + this.routeRole + '/push-notifications', title: 'Push Notifications', icon: 'now-ui-icons ui-1_bell-53', class: '', children: [] }
    ];

    this.resolverData = this.route.snapshot.data;

    if (this.role === 4) {
      this.roleMenuItems = SUPERROUTES.filter((roleMenuItem) => roleMenuItem);
      this.storeMenuItems = STOREROUTES.filter((storeMenuItem) => storeMenuItem);
    } else if (this.role === 3) {
      this.roleMenuItems = GROUPROUTES.filter((menuItem) => menuItem);
      this.storeMenuItems = STOREROUTES.filter((storeMenuItem) => storeMenuItem);
    } else if (this.role === 2) {
      this.roleMenuItems = OWNERROUTES.filter((menuItem) => menuItem);
      this.storeMenuItems = STOREROUTES.filter((storeMenuItem) => storeMenuItem);
    } else {
      console.log('No valid routes for user');
    }
  }

  isMobileMenu() {
    if (window.innerWidth > 991) {
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/sidebar/sidebar.component.ts